<script>
import { getOtherCampaign } from "@/api/campaigns";
import moment from "moment";
export default {
  name: "campaign-result-table",
  props: ["show", "locations", "campaign_id"],
  data() {
    return {
      search: "",
      singleSelect: false,
      selected: [],
      headers: [
        {
          text: "Location",
          align: "left",
          sortable: true,
          value: "name"
        },
        { text: "Customer", value: "customer" },
        { text: "Last 4 digits", value: "last_4_digits" },
        { text: "Auth Code", value: "auth_code" },
        { text: "Revenue", value: "revenue" },
        { text: "Time", value: "time" }
      ],
      items: [],
      loading: true,
      item: null
    };
  },
  async mounted() {
    // console.log("CampaignResultTable component...");
    // console.log("campaign_id", this.campaign_id);
    // console.log("locations", this.locations);
    if (this.campaign_id) {
      let item = await getOtherCampaign(this.campaign_id);
      if (item && item.all_locations && item.all_locations.length > 0) {
        let data = [];
        for (let i = 0; i < item.all_locations.length; i++) {
          let location = item.all_locations[i];
          data.push(location);
        }
        this.items = data;
        this.loading = false;
        this.item = item;
      }
    }
  },
  computed: {
    visible() {
      return this.show;
    },
    campaign_name() {
      return this.item && this.item.name
        ? `#${this.item.id} ${this.item.name}`
        : "";
    }
  },
  methods: {
    close() {
      this.$emit("close");
    },
    exporItems() {
      // console.log(this.selected);
      let items = [];
      if (this.selected.length == 0) {
        // The user wants to export all locations
        items = this.items;
      } else {
        // The user chose a selected locations
        for (let i = 0; i < this.selected.length; i++) {
          let item = this.selected[i];
          items.push(item);
        }
      }

      // console.log("items", items);
      let data = [];
      for (let i = 0; i < items.length; i++) {
        let item = items[i];
        data.push({
          id: item.id,
          name: item.name,
          customer: "",
          last_4_digits: "",
          auth_code: "",
          revenue: "",
          time: ""
        });
      }
      let csv = this.$papa.unparse(data);
      this.$papa.download(
        csv,
        `${this.campaign_name}-locations-${moment().format("YYYY-MM-DD-HH-mm")}`
      );
    }
  }
};
</script>
<template>
  <v-dialog v-model="visible" persistent scrollable width="70%">
    <v-card flat>
      <v-card-title>CAMPAIGN RESULT FOR {{ campaign_name }}</v-card-title>
      <v-row class="p-5">
        <v-col cols="12" md="8">
          <v-btn class="mr-4" depressed tile @click="exporItems()">
            <v-icon left> mdi-file-export </v-icon>
            Export
          </v-btn>
        </v-col>
        <v-col cols="12" md="4">
          <div class="input-group mb-3">
            <div class="input-group-prepend">
              <div class="input-group-text">
                <b-icon icon="search"></b-icon>
              </div>
            </div>
            <b-form-input v-model="search" placeholder="Search"></b-form-input>
          </div>
        </v-col>
      </v-row>

      <v-card-text>
        <v-data-table
          v-model="selected"
          :headers="headers"
          :items="items"
          show-select
          item-key="id"
          :search="search"
          :hide-default-header="false"
          :loading="loading"
          loading-text="Loading... Please wait"
        ></v-data-table>
      </v-card-text>
      <v-card-actions class="mt-20 p-5">
        <v-spacer></v-spacer>
        <v-btn class="mr-4" depressed tile @click="close">
          Close
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
